import {
  FranchiseType,
  LearnerCapacity,
  Proposition,
  PropositionAllocation,
} from "@hubcapp/types";
import { sortPropositionAllocationsForTabs } from "@hubcapp/utils";

import { PreferencesTab } from "./types";

export const getBrandTitle = (
  brand: Proposition["brand"],
  type?: Proposition["type"],
) => {
  if (type && type === FranchiseType.Dit) {
    return "";
  }
  return brand === "AADS" ? "AA" : "BSM";
};

export const getFranchiseTitle = (proposition: Proposition) =>
  `${getBrandTitle(proposition.brand, proposition.type)} ${
    proposition.transmission || ""
  }`.trim();

export const franchiseTypeLabelMap = {
  [FranchiseType.Full]: "Learners",
  [FranchiseType.PartnerLite]: "Learners",
  [FranchiseType.Solo]: "Learners",
  [FranchiseType.Trainee]: "Learners",
  [FranchiseType.ThirdParty]: "Learners",
  [FranchiseType.Dit]: "DIT",
  [FranchiseType.Motability]: "Motability",
};

export const learnerCapacityToUpdatedLearnerCapacity = ({
  id,
  maximum,
}: LearnerCapacity) => ({
  id,
  maximum,
});

export const getTabLabel = (
  shouldPrefixProposition = false,
  proposition: Proposition,
): string =>
  proposition.type
    ? `${shouldPrefixProposition ? getFranchiseTitle(proposition) + " " : ""}${
        franchiseTypeLabelMap[proposition.type]
      }`
    : "";

export const buildTabItems = (
  propositionAllocations: Array<PropositionAllocation>,
): Array<PreferencesTab> =>
  sortPropositionAllocationsForTabs(propositionAllocations || [])?.map(
    (propositionAllocation: PropositionAllocation) => {
      const isMultipleFranchises = propositionAllocations.length > 1;
      const type = propositionAllocation.proposition.type;

      const testId = type
        ? `preferences-tab-${franchiseTypeLabelMap[type].toLowerCase()}`
        : "";

      return {
        ["data-test"]: testId,
        key: propositionAllocation.id,
        label: getTabLabel(
          isMultipleFranchises,
          propositionAllocation.proposition,
        ),
        ["aria-label"]: getTabLabel(
          isMultipleFranchises,
          propositionAllocation.proposition,
        ),
        value: propositionAllocation.id,
      };
    },
  );

export const getPropositionCapacity = (
  learnerCapacity: Array<LearnerCapacity>,
  targetPropositionAllocationId: string,
) => {
  const filteredCapacityByLineItem = learnerCapacity.filter(
    (learnerCapacity: LearnerCapacity) =>
      learnerCapacity.lineItemKey === targetPropositionAllocationId,
  );

  if (filteredCapacityByLineItem.length === 0) {
    return undefined;
  }

  return filteredCapacityByLineItem[0];
};
